import { Tag } from "antd";
import styled from "styled-components";
import { theme } from "../../../../../theme";

const { CheckableTag } = Tag;

/**
 * round checkable tags
 */
const CheckRoundTag = styled(CheckableTag)`
  &.ant-tag-checkable {
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 6px 16px;
    border: 1px solid ${theme.colors.gray6};
    border-radius: 100px;
    gap: 8px;
    ${theme.typo.body.r14};
    color: ${theme.colors.gray3};

    &.ant-tag-checkable-checked {
      border: 1px solid ${theme.colors.mainPrimary3};
      color: ${theme.colors.mainPrimary3};
      background: ${theme.colors.white};
    }
  }
`;

const ReadonlyRoundTag = styled(Tag)`
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 6px 16px;

  border-radius: 100px;
  gap: 8px;
`;

export { CheckRoundTag, ReadonlyRoundTag };
